export const setMapInfo = (mapInfo) => ({
  type: "MAPINFO/SETMAPINFO",
  mapInfo,
});
